<script>
import ModelViewer from '@metamask/logo';

export default {
  name: 'MetaFox',
  mounted() {
    const viewer = ModelViewer({
      pxNotRatio: true,
      width: 100,
      height: 100,
      followMouse: false,
      slowDrift: false,
    });
    const container = document.getElementById('meta-fox');
    container.appendChild(viewer.container);
    viewer.lookAt({
      x: 100,
      y: 100,
    });
    viewer.setFollowMouse(true);
    viewer.stopAnimation();
  },
};
</script>

<template>
  <div id="meta-fox"></div>
</template>
